import { css } from 'lit';
import componentStyles from '../../styles/component.styles';
export default css `
${componentStyles}
/**
--------------------------------------------------
* General
--------------------------------------------------
*/
:host {
  display: block;
}

a {
  display: block;
  position: relative;
}

.video-card {
  border-radius: 10px;
  position: relative;
  aspect-ratio: 16/9;
}

figure {
  height: 100%;
  width: 100%;
  overflow: hidden;
  border-radius: 10px;
  aspect-ratio: 16/9;
  position: relative;
}

figure img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
  object-position: center;
  position: absolute;
  top: 0;
  left: 0;
  transition: transform 0.7s ease-out;
}

a:hover img {
  transform: scale(1.04);
}

.content {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: clamp(1.25rem, 2.1494rem + -1.8762vw, 0.625rem);
  z-index: 2;
  overflow: hidden;
}

.content::before {
  content: '';
  position: absolute;
  z-index: 1;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(0deg, var(--p-bg-dark, black) 0%, var(--p-bg-dark, black) 60%, transparent 100%);
  opacity: .75;
  border-radius: 0 0 10px 10px;
}

.hide-text a::before {
  display: none;
}

h2 {
  position: relative;
  z-index: 2;
  color: var(--p-text-color-light);
  font-family: var(--p-h4-font);
  font-size: var(--p-h4-font-size);
  font-weight: var(--p-h4-font-weight);
  font-style: var(--p-h4-font-style);
  line-height: var(--p-h4-line-height);
  text-transform: var(--p-h4-transform);
  letter-spacing: var(--p-h4-letter-spacing);
  margin: 0;
}

p {
  position: relative;
  z-index: 2;
  color: var(--p-text-color-light);
  font-size: .875rem;
  margin: .2em 0 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.play {
  top: 50%;
  left: 50%;
  z-index: 10;
  position: absolute;
  transform-origin: center;
  opacity: 0;
  scale: .9;
  translate: -50% -50%;
  transition: scale 350ms cubic-bezier(0.175, 0.885, 0.385, 1.85), opacity 200ms;
}
@media (prefers-reduced-motion) {
  .play {
    transition: none;
  }
}

a:hover .play {
  opacity: 1;
  scale: 1;
}

a:hover h2 {
  text-decoration: underline;
}

/**
--------------------------------------------------
* Preview
--------------------------------------------------
*/

.preview {
  background-color: #444;
}

.preview .content::before {
  display: none;
}

`;
